import React from 'react';
import { TableRow } from '@getsynapse/design-system';
import { UserDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import UserAvatar from 'Atoms/UserAvatar';
import { formatDate } from 'utils/formatters';

type UserDrillDownTableRowProps = {
  item: UserDrillDownItem;
};

const UserDrillDownTableRow: React.FC<UserDrillDownTableRowProps> = ({
  item,
}) => {
  return (
    <TableRow
      id={item.id}
      className='group cursor-pointer'
      cells={[
        {
          content: (
            <div className='flex items-center'>
              <UserAvatar
                size='small'
                user={{
                  avatar_url: item.user_data.avatar_url,
                  status: item.user_data.status,
                  data: {
                    firstName: item.user_data.first_name,
                    lastName: item.user_data.last_name,
                  },
                }}
                className='mr-2.5'
              />
              {`${item.user_name}`}
            </div>
          ),
        },
        {
          content: item.timeoff_hours_in_range || 0,
        },
        {
          content: item.default_capacity_hours_in_range || 0,
        },
        {
          content: item.capacity_hours_in_range || 0,
        },
        {
          content: item.allocated_hours_in_range || 0,
        },
        {
          content: item.actual_hours_in_range || 0,
        },
        {
          content: item.available_hours_in_range || 0,
        },
        {
          content: item.scheduled_hours_in_range || 0,
        },
        {
          content: item.job_title || '',
        },
        {
          content: <>{item.job_functions?.join(', ') || ''}</>,
        },
        {
          content: <>{item.skills?.join(', ') || ''}</>,
        },
        {
          content: (
            <>
              {item.learning_teams?.map((team) => team.name).join(', ') || ''}
            </>
          ),
        },
        {
          content: item.user_type || '',
        },
        {
          content: item.user_role || '',
        },
        {
          content: item.email || '',
        },
        {
          content: formatDate(item.created_at),
        },
        {
          content: item.last_login_date ? formatDate(item.last_login_date) : '',
        },
        {
          content: item.user_data.disabled_at
            ? formatDate(item.user_data.disabled_at)
            : '',
        },
      ]}
    />
  );
};

export default UserDrillDownTableRow;
